import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core';
import { PhoneService } from '../services';
import { PhoneList, Phone, Variant } from '../models';

@Component({
  selector: 'app-phone-list',
  templateUrl: './phone-list.component.html',
  styleUrls: ['./phone-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneListComponent implements OnInit, OnDestroy {
  private sub;
  @Input() phone: Phone;
  variants: Variant[] = [];
  suggestedVariants: Variant[] = [];

  constructor(private phoneService: PhoneService) { }

  ngOnInit() {
    this.variants = <Array<Variant>>Array.from(this.phone.variants.values());
    // FIXME ask to phone this.phone.getSuggestedVariants() and not use hilights
    this.sub = this.phoneService.obs.phoneList
      .subscribe((phoneList: PhoneList) => {
        this.suggestedVariants = <Array<Variant>>Array.from(phoneList.highlights.values());
      });
  }

  ngOnDestroy() { 
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/phone-list/phone-list.component.ts